import {
    Avatar,
    Box,
    Card,
    Grid,
    IconButton,
    Dialog as MUIDialog,
    DialogContent as MUIDialogContent,
    DialogTitle as MUIDialogTitle,
    styled,
    Typography,
} from '@mui/material';
import { OutcomeFactorTableHeader, OutcomeFactorTableRow } from '@/components/Scan/Outcomes/OutcomeFactorTable/styles';
import { OutcomeSliderFactorDescription, OutcomeSliderWrapper } from '@/components/Scan/Outcomes/OutcomeSlider/styles';

export const Dialog = styled(MUIDialog)(({ theme }) => ({
    minWidth: '1000px',
    '.MuiDialogContent-root': {
        paddingTop: `${theme.spacing(1)}!important`,
    },
}));

export const DialogTitle = styled(MUIDialogTitle)(({ theme }) => ({
    fontSize: theme.typography.h3.fontSize,
}));

export const DialogContent = styled(MUIDialogContent)(({ theme }) => ({
    minWidth: '1100px',
}));

export const TypographyWrapper = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(4),
    display: 'flex',
}));

export const OutcomeContainer = styled(Box)(({ theme }) => ({
    width: 1400,
}));

export const OutcomesContentWrapper = styled(Card)(({ theme }) => ({
    minHeight: 320,
    margin: theme.spacing(4),
    marginTop: 0,
    marginBottom: 0,
    [`${OutcomeSliderFactorDescription}`]: {
        color: theme.palette.grey[900],
    },
    [`${OutcomeFactorTableHeader}`]: {
        color: theme.palette.grey[700],
    },
    [`${OutcomeFactorTableRow}`]: {
        color: theme.palette.grey[700],
    },
    [`${OutcomeSliderWrapper}`]: {
        marginTop: theme.spacing(4),
    },
}));

export const OutcomeBuilderModalWrapper = styled(Dialog)(({}) => ({
    width: '100%',
    height: '100%',

    '& > .MuiDialog-container > .MuiPaper-root': {
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        maxHeight: 'none',
        margin: 0,
        borderRadius: 0,
    },
}));

export const OutcomeBuilderCloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: 0,
    top: '12px',
    color: theme.palette.grey[500],
    [theme.breakpoints.up('lg')]: {
        right: 0,
        top: '-10px',
    },
}));

export const OutcomeBuilderCloseModalBody = styled('p')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(6),
}));

export const OutcomeBuilderWrapper = styled('div')(({ theme }) => ({
    background: theme.palette.neutral.main,
    height: '10000%',
}));

export const OutcomeBuilderHeaderRight = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexBasis: '200px',
        position: 'relative',
    },
}));

export const OutcomeBuilderHeader = styled('header')(({ theme }) => ({
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    justifyContent: ' space-between',
    alignItems: 'flex-start',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
    },

    '& h2': {
        fontSize: 18,
        fontWeight: 'normal',
        margin: 0,
    },
}));

export const OutcomeBuilderNav = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
        marginTop: '0',
    },
}));

export const OutcomeBuilderNavItem = styled(Typography)<{ $isActive: boolean }>(({ theme, $isActive }) => ({
    textDecoration: 'none',
    position: 'relative',
    marginRight: theme.spacing(2.5),
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: $isActive ? theme.palette.primary[500] : theme.palette.grey[400],
    [theme.breakpoints.up('lg')]: {
        marginLeft: theme.spacing(1),
    },
}));

export const OutcomeBuilderNavItemBullet = styled('span')(({ theme }) => ({
    fontSize: 32,
    marginRight: theme.spacing(1),
    lineHeight: 0,
}));

export const OutcomeBuilderStepIndicator = styled(Avatar)(({ theme }) => ({
    background: theme.palette.primary[200],
    color: theme.palette.primary[500],
    marginRight: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    width: '20px',
    height: '20px',
    fontSize: theme.typography.caption.fontSize,
}));

export const OutcomeBuilderFooter = styled(Grid)(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    width: '100%',
    background: theme.palette.common.white,
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: '0 -2px 4px rgba(16,24,64,.05)',
    zIndex: '50',

    '& .MuiButton-root .MuiSvgIcon-root': {
        margin: 0,
    },
    [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
    },
}));

const OUTCOME_BUILDER_FOOTER_HEIGHT = 90;
export const OutcomeBuilderContent = styled('div')<{ $fullScreen?: boolean }>(({ theme, $fullScreen }) => ({
    padding: $fullScreen ? 0 : theme.spacing(2),
    marginTop: theme.spacing(2),
    paddingBottom: $fullScreen ? OUTCOME_BUILDER_FOOTER_HEIGHT : OUTCOME_BUILDER_FOOTER_HEIGHT + 30,
    paddingTop: $fullScreen ? 0 : theme.spacing(3),
    '& .MuiInputBase-input': {
        fontSize: 14,
    },
    '& .MuiMenuItem-root': {
        fontSize: 14,
    },
    [theme.breakpoints.up('lg')]: {
        padding: $fullScreen ? 0 : theme.spacing(3),
        paddingLeft: $fullScreen ? 0 : theme.spacing(8),
        paddingRight: $fullScreen ? 0 : theme.spacing(8),
        paddingBottom: $fullScreen ? OUTCOME_BUILDER_FOOTER_HEIGHT : OUTCOME_BUILDER_FOOTER_HEIGHT + 30,
    },
}));
